function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.88534 6.04166H3.427C2.55706 6.04262 1.72302 6.38863 1.10788 7.00378C0.492734 7.61892 0.146722 8.45296 0.145757 9.32291V12.9687C0.145386 13.0368 0.164073 13.1036 0.199705 13.1616C0.235336 13.2196 0.286488 13.2664 0.347372 13.2969L1.61977 13.9331L1.96867 18.828C1.97523 18.9201 2.01652 19.0063 2.08419 19.0692C2.15187 19.132 2.24088 19.1669 2.33326 19.1667H5.97909C6.07146 19.1669 6.16047 19.132 6.22815 19.0692C6.29582 19.0063 6.33711 18.9201 6.34367 18.828L6.69367 13.9312L7.96606 13.295C8.02647 13.2646 8.07721 13.218 8.11262 13.1603C8.14803 13.1027 8.16672 13.0364 8.16658 12.9687V9.32291C8.16562 8.45296 7.81961 7.61892 7.20446 7.00378C6.58932 6.38863 5.75528 6.04262 4.88534 6.04166Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.15609 5.31251C5.56556 5.31251 6.70817 4.1699 6.70817 2.76043C6.70817 1.35095 5.56556 0.208344 4.15609 0.208344C2.74661 0.208344 1.604 1.35095 1.604 2.76043C1.604 4.1699 2.74661 5.31251 4.15609 5.31251Z"
});

var SvgPerson = function SvgPerson(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 20,
    viewBox: "0 0 9 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPerson, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/person.ded97e50.svg";
export { ForwardRef as ReactComponent };